import React from 'react';
import { ShieldCheck, Terminal } from 'lucide-react';
import GphRichBlock from '../GphRichBlock';

export default function AdminPanelAdapter({ agent }) {
  return (
    <GphRichBlock eyebrow="MÓDULO TÁTICO" title="PAINEL DE ADMINISTRAÇÃO" subtitle="Acesso operacional com privilégios de administrador.">
      <div className="space-y-6 pt-2 text-left">
        <div className="border-l-2 border-lime-500 pl-4 py-1 flex items-center gap-2.5 text-xs text-lime-300 font-mono">
          <ShieldCheck size={16} className="text-lime-400 shrink-0" />
          <span>Credencial de Administrador autenticada com sucesso.</span>
        </div>
        <div className="border-t border-white/5 pt-5 mt-6 flex items-center justify-between">
          <button
            type="button"
            className="gph-btn gph-btn--primary text-xs flex items-center gap-1.5"
            onClick={() => agent.host.openAdminPanel?.()}
          >
            <Terminal size={14} /> Abrir Painel ADM
          </button>
          <button type="button" className="gph-btn gph-btn--ghost text-xs" onClick={() => agent.restart()}>
            Voltar ao Chat
          </button>
        </div>
      </div>
    </GphRichBlock>
  );
}
